import { useContext, useMemo } from 'react';
import './Agreement.scss';
import { TranslationContext } from '@app/contexts/translationContext';

export default function Agreement() {
    const { contextTranslation } = useContext(TranslationContext);

    const texts = useMemo(
        () => contextTranslation.Agreement,
        [contextTranslation],
    );

    return (
        <div className="agreement container">
            {texts.sections.map(
                (section: { title: string; texts: string[] }, i: number) => (
                    <section key={`agreement section #${i}`}>
                        <h4>{section.title}</h4>
                        {section.texts.map((paragraph: string, k: number) => (
                            <p key={`agreement section #${i} paragraph #${k}`}>
                                {paragraph}
                            </p>
                        ))}
                    </section>
                ),
            )}
        </div>
    );
}
